<template>
  <div id="main-page">
    <template>
    <!-- 二维码 -->
    <div v-if="contactPanel" class="contact bg wx">
      <div class="scan-code">
        <div class="code">
          <img src="../assets/wechat_code1.png" alt="">
        </div>
      </div>
    </div>
    <div v-if="contactPanel1" class="contact bg wb">
      <div class="scan-code">
        <div class="code">
          <img src="../assets/weibo_code1.png" alt="">
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <div v-if="isDesktop" class="nav">
      <div class="top bg">
        <div class="nav-box">
          <div
            :class="[ nowIndex + 1  === item ? 'nav-active':'']"
              @click="goAnchor(item)"
              v-for="item in navArray"
              :key="item">
            <img
            class="go "
            :src="require(`../assets/${targetFolder}/nav/${item}${ nowIndex + 1  === item ? '_active':''}.png`)">
          </div>
        </div>
        <div class="action-container">
          <img
            class="wechat-button"
              :src="contactPanel === false ? require(`../assets/${targetFolder}/1/ico1.png`) : require(`../assets/${targetFolder}/1/ico1_active.png`)"
            @click="contactPanel = !contactPanel;contactPanel1 = false">
          <img
            class="wechat-button"
              :src="contactPanel1 === false ? require(`../assets/${targetFolder}/1/ico2.png`) : require(`../assets/${targetFolder}/1/ico2_active.png`)"
            @click="contactPanel1 = !contactPanel1;contactPanel = false">
          <a href="https://tieba.baidu.com/wxf/27469939?kw=%E5%85%A8%E6%B0%91%E5%AD%A6%E9%9C%B8%E6%89%8B%E6%B8%B8&fr=sharewise&source=12_16_sharecard_a" target='_blank'>
              <img
              class="tieba-button"
              :src="require(`../assets/${targetFolder}/1/ico3.png`)"
              >
          </a>
          <a href="https://v.douyin.com/6HuBcKP/" target='_blank'>
              <img
              class="dy-button"
              :src="require(`../assets/${targetFolder}/1/ico4.png`)"
              >
          </a>
        </div>
      </div>
    </div>
    <div v-else class="nav bg">
      <div class="top bg">
        <div class="nav-box">
          <img class="logo" :src="require(`../assets/${targetFolder}/nav/logo.png`)" />
          <div class="action-container" >
            <img
              class="wechat-button"
                :src="contactPanel === false ? require(`../assets/${targetFolder}/nav/ico1.png`) : require(`../assets/${targetFolder}/nav/ico1_active.png`)"
              @click="contactPanel = !contactPanel;contactPanel1 = false;classification=false">
            <img
              class="wechat-button"
                :src="contactPanel1 === false ? require(`../assets/${targetFolder}/nav/ico2.png`) : require(`../assets/${targetFolder}/nav/ico2_active.png`)"
              @click="contactPanel1 = !contactPanel1;contactPanel = false;classification=false">
            <a class="tieba-button" href="https://tieba.baidu.com/wxf/27469939?kw=%E5%85%A8%E6%B0%91%E5%AD%A6%E9%9C%B8%E6%89%8B%E6%B8%B8&fr=sharewise&source=12_16_sharecard_a" target='_blank'>
                <img
                class="tieba-button"
                :src="require(`../assets/${targetFolder}/nav/ico3.png`)"
                >
            </a>
            <a class="dy-button" href="https://v.douyin.com/6HuBcKP/" target='_blank'>
                <img
                class="dy-button"
                :src="require(`../assets/${targetFolder}/nav/ico4.png`)"
                >
            </a>
            <img
            class="classification"
              :src="classification === false ? require(`../assets/${targetFolder}/nav/classification.png`) : require(`../assets/${targetFolder}/nav/classification_active.png`)"
            @click="classification = !classification;contactPanel = false;contactPanel1 = false">
          </div>
        </div>
      </div>
      <div class="bottom" v-if="classification">
          <div
            :class="[ nowIndex + 1  === item ? 'nav-active':'']"
              @click="goAnchor(item)"
              v-for="item in navArray"
              :key="item">
            <img
            class="go "
            :src="require(`../assets/${targetFolder}/nav/${item}${ nowIndex + 1  === item ? '_active':''}.png`)">
          </div>
      </div>
    </div>
    <full-page ref="fullpage" :options="options.fullpage" id="fullpage">
      <div class="section page1 bg">
        <template v-if="isDesktop">
          <div class="page1-logo" ></div>
          <div class="slogan">
            <img @click="showVideo" :src="require(`../assets/${targetFolder}/1/play_button.png`)" class="play">
          </div>
          <div class="download-box">
              <img class="download_code" :src="require(`../assets/${targetFolder}/1/download_code.png`)">
              <img @click="downloadPc" class="download_pc" :src="require(`../assets/${targetFolder}/1/download_pc.png`)">
              <div class="code">
                <img @click="downloadAnd" :src="require(`../assets/${targetFolder}/1/download_and.png`)">
                <img @click="downloadIos" :src="require(`../assets/${targetFolder}/1/download_ios.png`)">
              </div>
              <div class="tip_12 bg" @click="showTip = true"></div>
            </div>
          <!-- <div class="content">
            <div class="slogan">
              <img :src="require(`../assets/${targetFolder}/1/slogan.png`)" class="slogan">
              <img @click="showVideo" :src="require(`../assets/${targetFolder}/1/play_button.png`)" class="play">
            </div>
            <div class="download-box">
                <img class="download_code" :src="require(`../assets/${targetFolder}/1/download_code.png`)">
                <div class="code">
                  <img @click="downloadAnd" :src="require(`../assets/${targetFolder}/1/download_and.png`)">
                  <img @click="downloadIos" :src="require(`../assets/${targetFolder}/1/download_ios.png`)">
                </div>
                <img @click="downloadPc" class="download_pc" :src="require(`../assets/${targetFolder}/1/download_pc.png`)">
                <div class="tip_12 bg" @click="showTip = true"></div>

            </div>
          </div> -->
        </template>
        <template v-else>
          <div class="content">
            <div class="page1-logo" ></div>
            <div class="slogan">
              <img :src="require(`../assets/${targetFolder}/1/slogan.png`)" class="slogan">
              <img @click="showVideo" :src="require(`../assets/${targetFolder}/1/play_button.png`)" class="play">
              <!-- <img :src="require(`../assets/${targetFolder}/1/slogan_1.png`)" class="sub_slogan"> -->
            </div>
            <img class="download" @click="downloadMobile" :src="require(`../assets/${targetFolder}/1/download.png`)" />
            <div class="tip_12 bg" @click="showTip = true"></div>
            <!-- <div class="download-box">
              <img class="download-code" :src="require(`../assets/${targetFolder}/1/download_code.png`)"/>
              <img @click="downloadPc" class="download-pc" :src="require(`../assets/${targetFolder}/1/download_pc.png`)"/>
              <div class="code">
                <img @click="downloadIos" :src="require(`../assets/${targetFolder}/1/download_ios.png`)">
                <img @click="downloadAnd" :src="require(`../assets/${targetFolder}/1/download_and.png`)">`
              </div>
              <div class="tip_12 bg" @click="showTip = true"></div>
              <a class="link" href="https://qmxb.gm88.com/#/news/newest/9579">
                  <img :src="require(`../assets/${targetFolder}/1/link.png`)">
              </a>
            </div> -->
          </div>
        </template>
      </div>
      <!--新官网第二屏幕-->
      <div class="section page2 bg">
        <template>
          <div class="content">
            <img v-if="!isDesktop" class="img-title" :src="require(`../assets/${targetFolder}/2/title.png`)" />
            <div v-if="isDesktop" class="left-box bg">
              <img class="character" :src="require(`../assets/desktop/2/character.png`)" />
              <img class="news-title" :src="require(`../assets/desktop/2/news_title.png`)" />
            </div>
            <div class="swiper-box bg">
              <div class="carousel bg" @click="carouselClick">
                <swiper
                    ref="carousel"
                    :options="options.carousel" >
                    <swiper-slide v-for="item in page2List" :key="item.id" >
                      <img
                        :data-url="item.url"
                        :src="isDesktop ? item.pc : item.wap">
                    </swiper-slide>
                    <div
                      class="swiper-pagination carousel-pagination"
                      slot="pagination"></div>
                </swiper>
              </div>
              <img class="pen" :src="require(`../assets/${targetFolder}/2/pen.png`)" />
            </div>
            <div class="right-box">
              <div class="category">
                <span
                  v-for="item in articleCategory"
                  :class="{
                    active: activeArticleCategory === item.value
                  }"
                  :key="item.value"
                  @click="changeArticleCategory(item.value)"
                >[{{item.label}}]</span>
              </div>
              <div
                @click="topNewsClick"
                class="top-news" :title="topNews.title" :style="{opacity:(topNews.title!=='占位'? 1:0)}">
                {{topNews.title}}
              </div>
              <div class="article-list">
                <div
                  class="row dashed"
                  v-for="(item) in articleList"
                  :key="item.id">
                  <span :title="item.title" @click="$router.push(`news/${activeArticleCategory}/${item.id}`)" class="title">【{{item.cate_name }}】{{ item.title }}</span>
                  <span class="date">{{ parseTime(item.add_time + '000','{m}.{d}') }}</span>
                </div>
              </div>
              <img class="more" :src="require(`../assets/${targetFolder}/2/more.png`)" @click="changeArticleCategory('more')"/>
              <img v-if="!isDesktop" class="underline" :src="require(`../assets/${targetFolder}/2/underline.png`)" />
            </div>
          </div>
        </template>
      </div>
      <!--新官网第三屏幕-->
      <div class="section page3 bg">
        <div class="content">
          <div class="light bg"></div>
          <div class="page3-title page3-title1 bg" @click="openDialog(4)"></div>
          <div class="page3-title page3-title2 bg" @click="openDialog(1)"></div>
          <div class="page3-title page3-title3 bg" @click="openDialog(2)"></div>
          <div class="page3-title page3-title4 bg" @click="openDialog(3)"></div>
          <img class="television" :src="require(`../assets/${targetFolder}/3/television.png`)"  />
          <img class="easel" :src="require(`../assets/${targetFolder}/3/easel.png`)"  />
          <img v-if="isDesktop" class="shadow" :src="require(`../assets/${targetFolder}/3/shadow.png`)"  />
          <img class="table" :src="require(`../assets/${targetFolder}/3/table.png`)"  />
          <img v-if="isDesktop" class="book" :src="require(`../assets/${targetFolder}/3/book.png`)"  />
        </div>
      </div>
      <!--新官网第四屏幕-->
      <div class="section page4 bg">
        <div class="content">
          <img class="img-title" :src="require(`../assets/${targetFolder}/4/title.png`)">
          <div class="game-carousel">
            <div class="game-box">
                <swiper ref="game" :options="options.game">
                <swiper-slide
                  class="swiper-no-swiping"
                  v-for="item in gameSlides"
                  :key="item">
                  <img style="width:100%" :src="require(`../assets/swiper/${item}`)">
                </swiper-slide>
                <div
                class="swiper-pagination carousel-pagination"
                slot="pagination"></div>
              </swiper>
            </div>
            <img class='compasses' :src="require(`../assets/${targetFolder}/4/compasses.png`)" />
            <img class='pen' :src="require(`../assets/${targetFolder}/4/pen.png`)" />
          </div>
          <img class="prev" @click="gamePre" :src="require(`../assets/${targetFolder}/4/prev.png`)" />
          <img class="next"  @click="gameNext" :src="require(`../assets/${targetFolder}/4/next.png`
          )" />
          <template>
          <div class="message" v-if="isDesktop">
            <p class="margin">健康游戏忠告</p>
            <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
            <p>Copyright © 2014-2020 Shanghai Gume Technology Co.,Ltd All Rights Reserved. 上海咕么信息科技有限公司 版权所有</p>
            <p>ICP备案号：沪ICP备16011695号-1 沪网文（2016）2295-133号</p>
          </div>
          <div class="message" v-if="!isDesktop">
            <p class="margin">健康游戏忠告</p>
            <p>抵制不良游戏，拒绝盗版游戏。注意自我保护，谨防受骗上当。</p>
            <p>适度游戏益脑，沉迷游戏伤身。合理安排时间，享受健康生活。</p>
            <p>Copyright © 2014-2020 Shanghai Gume Technology Co.,Ltd All Rights Reserved.</p>
            <p>上海咕么信息科技有限公司 版权所有</p>
            <p>ICP备案号：沪ICP备16011695号-1 沪网文（2016）2295-133号</p>
          </div>
          </template>
        </div>
      </div>
    </full-page>
    <div class="tip-panel" v-if="showTip" @click="showTip = false">
      <div class="content bg"  @click="showTip = false">
        <div class="title">
        《全民学霸》适龄提示
        </div>
        <div class="text_row">
          1.本游戏是一款模拟经营养成游戏，适用于年满12周岁及以上的用户，建议未成年人在家长监护下使用游戏产品。
        </div>
        <div class="text_row">
        2.本游戏通过游戏界面的交互、角色收集、关卡对战等玩法推进剧情。游戏中有少量基于文字的陌生人社交系统。
        </div>
        <div class="text_row">
        3.本游戏中有用户实名认证系统，认证为未成年人的用户将接受以下管理：
        游戏中有部分的付费道具。未满8周岁的用户不能付费；8周岁以上未满16周岁的未成年人用户，单次充值金额不得超过50元人民币，每月充值金额累计不得超过200元人民币；16周岁以上的未成年人用户，单次充值金额不得超过100元人民币，每月充值金额累计不得超过400元人民币。
        未成年人用户仅可在周五、周六、周日和法定节假日的20时至21时，进行1小时的游戏体验。
        </div>
        <div class="text_row">
        4.本游戏以收集养成为主。游戏以校园经营为蓝图，画风卡通怀旧，带玩家体验青春校园的时光，可以给玩家带来舒适愉悦的正面情绪。
        </div>
      </div>
    </div>
    <video-viewr ref="video" />
    </template>
    <!--视听中心-->
    <AudioVisual ref="dialog1" @closeDialog='closeDialog'/>
    <!--同人创作-->
    <SamePerson ref="dialog2" @closeDialog='closeDialog' />
    <!--学生档案-->
    <StudentFiles ref="dialog3" @closeDialog='closeDialog'/>
    <!--黑板报-->
    <BlackBoard ref="dialog4" @closeDialog='closeDialog' />
  </div>
</template>

<script>
import AudioVisual from './AudioVisual.vue'
import SamePerson from './SamePerson.vue'
import StudentFiles from './StudentFiles.vue'
import BlackBoard from './BlackBoard.vue'
import VideoViewr from './Video_1.vue'
import {
  getArticleCategory,
  getArticleList,
  getWebSiteContent
} from '@/api'
import { parseTime } from '@/utils'
export default {
  name: 'Home',
  components: {
    VideoViewr,
    AudioVisual,
    SamePerson,
    StudentFiles,
    BlackBoard
  },
  data () {
    const self = this
    return {
      gifSrc: '',
      gameSlides: ['5-1.jpg', '5-2.jpg', '5-3.jpg', '5-4.jpg', '5-5.jpg'],
      topNews: {
        // article_id: '1',
        // title: '置顶新闻'
      },
      contactPanel: false,
      contactPanel1: false,
      classification: false,
      showTip: false,
      device: window.device,
      nowIndex: 0,
      activeRoleIndex: '1',
      carouselActiveIndex: 1,
      activeArticleCategory: '1',
      articleCategory: [
        {
          label: '最新',
          value: '1'
        }, {
          label: '新闻',
          value: '2'
        }, {
          label: '公告',
          value: '3'
        }, {
          label: '活动',
          value: '4'
        }, {
          label: '更多',
          value: 'more'
        }
      ],
      articleList: [
      ],
      navArray: [
        1,
        2,
        3,
        4
      ],
      options: {
        game: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          loop: true,
          // noSwiping: true
          autoplay: {
            disableOnInteraction: false,
            delay: 5000
          }
        },
        carousel: {
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            disableOnInteraction: false,
            delay: 5000
          },
          loop: true
        },
        fullpage: {
          // menu: '#menu',
          // lockAnchors: false,
          // navigation: false,
          // navigationPosition: 'right',
          // showActiveTooltip: false,
          // slidesNavigation: false,
          // slidesNavPosition: 'bottom',
          onLeave (index, nextIndex) {
          // console.log(index.index)
          // console.log(self)
          // console.log(arr)
            self.contactPanel = false
            self.contactPanel1 = false
            self.showTip = false
            self.nowIndex = nextIndex.index
          }
        }
      },
      areaActive: 0,
      swiperIndex: 0,
      page2List: [] // 轮播图数据
    }
  },
  watch: {
  },
  created () {
    require(`../styles/${this.targetFolder}/index.scss`)
    // require(`../styles/${this.targetFolder}/index.scss`)
  },
  computed: {
    isLogin () {
      return !!this.userInfo
    },
    gameSwiper () {
      return this.$refs.game.$swiper
    },
    targetFolder () {
      return this.$store.state.targetFolder
    },
    isDesktop () {
      return this.$store.state.isDesktop
    }
  },
  mounted () {
    if (this.$route.query.anchor) {
      this.goAnchor(this.$route.query.anchor)
    }
    this.init()
    this.getWebSiteContent()
  },
  methods: {
    closeDialog () {
      this.$refs.fullpage.api.setAllowScrolling(true)
    },
    openDialog (value) {
      this.$refs['dialog' + value].show = true
      this.$refs['dialog' + value].getWebSiteContent()
      this.$refs.fullpage.api.setAllowScrolling(false)
    },
    init () {
      this.getArticleCategory()
    },
    parseTime,
    open (url) {
      location.href = url
      // window.open(url)
    },
    carouselClick (e) {
      const target = e.target
      if (target.nodeName === 'IMG') {
        window.location.href = target.getAttribute('data-url')
      }
    },
    showVideo () {
      this.$refs.video.doShow()
    },
    async getArticleCategory () {
      try {
        const sort = ['公告', '活动', '新手攻略', '进阶攻略', '公益']
        const { data } = await getArticleCategory()
        this.articleCategory = []
        let temp = []
        sort.forEach(v => {
          const target = data.find(t => t.cate_name === v)
          if (target) {
            temp.push({
              label: target.cate_name,
              value: target.cate_id
            })
          }
        })
        temp = [...temp]
        temp.unshift({
          label: '最新',
          value: 'newest'
        })
        this.articleCategory = temp
        this.activeArticleCategory = temp[0].value
        this.getArticList()
      } catch (e) {
        console.log(e)
        alert(e.message)
      }
    },
    async getArticList () {
      try {
        const params = {
          cate_id: this.activeArticleCategory,
          limitsize: 4
        }
        if (this.activeArticleCategory === 'newest') {
          params.cate_id = undefined
        }
        const { data } = await getArticleList(params)
        // console.log(data)
        this.articleList = data.result
        if (data.topData && data.topData.length >= 1) {
          this.topNews = data.topData[0]
        } else {
          this.topNews = { title: '占位' }
        }

        console.log(this.topNews)
        // console.log(data.topData)
      } catch (e) {
        console.log(e)
        // alert(e.message)
      }
    },
    // 新版官网获取数据
    async getWebSiteContent () {
      try {
        const params = {
          type: 1
        }
        const { data } = await getWebSiteContent(params)
        this.page2List = data
      } catch (error) {
        console.log(error)
      }
    },
    topNewsClick () {
      if (this.topNews.title !== '占位') {
        this.$router.push(`news/${this.activeArticleCategory}/${this.topNews.article_id}`)
      }
    },
    downloadPc () {
      window._hmt.push(['_trackEvent', '游戏', 'click-PC-download'])
      location.href = 'https://cdn.school.nu5ru.com/school_online/pc/5064/install/qmxb_5064_1_0_1_x86_install.exe'
    },
    downloadIos () {
      window._hmt.push(['_trackEvent', '游戏', 'click-iOS-download'])
      location.href = 'https://apps.apple.com/cn/app/id1556383376'
    },
    downloadAnd () {
      window._hmt.push(['_trackEvent', '游戏', 'click-Android-download'])
      location.href = 'https://apk.gm88.com/dl/qmxb-4946-20240604-1.6.3/qmxb-4946-20240604-1.6.3.17.4f0c5005874e5fd2c8660f8a2f81977e.apk'
    },
    downloadMobile () {
      if (window.device.os === 'android') {
        location.href = 'https://apk.gm88.com/dl/qmxb-4946-20240604-1.6.3/qmxb-4946-20240604-1.6.3.17.4f0c5005874e5fd2c8660f8a2f81977e.apk'
      } else {
        location.href = 'https://apps.apple.com/cn/app/id1556383376'
      }
    },
    goAnchor (v) {
      this.contactPanel = false
      this.$refs.fullpage.api.moveTo(v)
    },
    changeArticleCategory (value) {
      if (value === 'more') {
        this.$router.push('/news/' + this.activeArticleCategory)
      } else {
        this.activeArticleCategory = value
        this.getArticList()
      }
    },
    gamePre () {
      this.gameSwiper.slidePrev()
    },
    gameNext () {
      this.gameSwiper.slideNext()
    }
  }

}
</script>
<style lang="scss">
  // @import '@/styles/index.scss';
</style>
